import { call, put } from 'redux-saga/effects';

import { getStringByteSize } from '../../globalHelpers';
import { validate } from '../../validate';
import { DOC_UPLOAD_BANNER_ERROR_MESSAGES } from '../constants';
import { getBase64FromURI } from './helpersMobile';

export function* processFileSaga({
  processDocumentFailure,
  processDocumentSuccess,
}, { payload }) {
  try {
    const {
      file: { name },
      isSecondFile,
      mobile: { uri },
    } = payload;
    const fileType = name.split('.').pop();
    let { mobile: { base64 } } = payload;
    // DocumentPicker method doesn't provide base64, only the uri
    if (!base64) {
      base64 = yield call(getBase64FromURI, uri);
    }
    /**
     * The ImagePicker and DocumentPicker methods provide size, but they are different (smaller)
     * than the size of the base64 string.
     */
    const size = getStringByteSize(base64);

    const file = { data: base64, name, size };
    const validationError = validate({
      required: true,
      type: 'fileInput',
      value: { size, type: fileType },
    });

    if (validationError) {
      const { error, message } = validationError;
      const errorCodeToUse = error === 'invalidFileSize' ? 27000.1002 : '27000.1000';
      const bannerError = DOC_UPLOAD_BANNER_ERROR_MESSAGES[errorCodeToUse];
      yield put(processDocumentFailure({
        bannerError,
        file,
        isSecondFile,
        validationError: message,
      }));
    } else {
      yield put(processDocumentSuccess({ file, isSecondFile }));
    }
  } catch {
    const bannerError = DOC_UPLOAD_BANNER_ERROR_MESSAGES.default;
    yield put(processDocumentFailure({ bannerError }));
  }
}
